import { forwardRef } from "react";
function SvgRawCloseIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="m8 8 16 16M8 24 24 8"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawCloseIcon);
export default ForwardRef;
